const objectfit = function (el) {
    document.addEventListener('DOMContentLoaded', () => {
        if (!('object-fit' in document.body.style)) {
            let objectFitContainer;

            if (!el || !el.length) {
                objectFitContainer = document.querySelectorAll('.object-fit');
            } else {
                objectFitContainer = el.querySelectorAll('.object-fit');
            }

            // convert to Array for IE
            objectFitContainer = Array.prototype.slice.call(objectFitContainer);

            objectFitContainer.forEach(container => {
                let img = container.querySelector('img'),
                    imgUrl, objectfitFallbackUrl;

                if (!img) {
                    return;
                }

                imgUrl = img.src;
                objectfitFallbackUrl = img.getAttribute('data-objectfit');

                if (objectfitFallbackUrl) {
                    imgUrl = objectfitFallbackUrl;
                }

                if (imgUrl) {
                    container.style.backgroundImage = `url(${imgUrl})`;
                    container.classList.add('compat-object-fit');
                }
            });
        }
    });
};

objectfit();

export default objectfit;



// WEBPACK FOOTER //
// ./resources/assets/js/polyfill/object-fit.js